import React from "react";
import { Modal } from "react-bootstrap";

const DeleteModal = ({ showDelete, handleDeleteClose, textMessage,deleteFunction }) => {
  return (
    <Modal show={showDelete} onHide={handleDeleteClose} className="">
      <>
        <div className="text-center py-4">
          {" "}
          <h3>Confirm Deletion</h3>
        </div>

        <div className="text-center py-2  px-3">
          <h6 style={{ color: "#535353" }} className="">
            {textMessage}
          </h6>
        </div>
        <div>
          <div className="d-flex justify-content-center align-items-center gap-3 py-3">
            <button onClick={handleDeleteClose} className="btn btn-light px-5">Cancel</button>
            <button onClick={deleteFunction} className="btn btn-danger px-5">Delete</button>
          </div>
        </div>
      </>
    </Modal>
  );
};

export default DeleteModal;
